// Campus photo for /colleges/north-carolina-state-university: CC0 1.0, by Warren LeMay from Cincinnati, OH, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHolladay_Hall%2C_North_Carolina_State_University%2C_Raleigh%2C_NC_(28221621898).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/north-carolina-state-university/; credited under the photo.
const photo = {
    "slug": "north-carolina-state-university",
    "alt": "Holladay Hall on the North Carolina State University campus in Raleigh, North Carolina",
    "src": "/colleges/north-carolina-state-university/campus-1600.webp",
    "srcSmall": "/colleges/north-carolina-state-university/campus-800.webp",
    "srcMid": "/colleges/north-carolina-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/north-carolina-state-university/og.jpg",
    "title": "Holladay Hall, North Carolina State University, Raleigh, NC (28221621898)",
    "author": "Warren LeMay from Cincinnati, OH, United States",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHolladay_Hall%2C_North_Carolina_State_University%2C_Raleigh%2C_NC_(28221621898).jpg",
    "read": "2026-10-01"
};

export default photo;
